var Isotope = require('isotope-layout');
var jQueryBridget = require('jquery-bridget');
jQueryBridget('isotope', Isotope, $);

jQuery(function ($) {
    var qsRegex;
    var filterValue = '';
    var $filterOptions = $('.filters option');

    // init Isotope
    var $grid = $('.grid').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        layoutMode: 'fitRows',
        filter: function () {
            var $this = $(this);
            var searchResult = qsRegex ? $this.text().match(qsRegex) || $this.data('tags').match(qsRegex) : true;
            var filterResult = filterValue ? $this.is(filterValue) : true;
            return searchResult && filterResult;
        }
    });

    $grid[0].addEventListener('load', (function(){
        var runs;
        var update = function(){
            $grid.isotope('layout');
            runs = false;
        };
        return function(){
            if(!runs){
                runs = true;
                setTimeout(update, 33);
            }
        };
    }()), true);

    // filter items on option select
    $('.filters').on('change', 'select', function () {
        filterValue = '';
        // map input values to an array
        var inclusives = [];
        $('.filters select').each(function () {
            var filter = $(this).find(':selected').data('filter');
            if (filter !== '*') {
                inclusives.push( filter );
                filterValue += filter;
            }
            // combine filters for url
            var hashValue = inclusives.join('');
            location.hash = 'filter=' + encodeURIComponent( hashValue );

        });
        updateFilterCounts();
    });

    function updateFilterCounts() {
        // get filtered item elements
        var itemElems = $grid.isotope('getFilteredItemElements');
        var $itemElems = $(itemElems);
        $filterOptions.each(function (i, option) {
            var $option = $(option);
            var filterValue = $option.attr('data-filter');
            if (filterValue === '*') {
                // do not update 'any' options
                return;
            }
            var count = $itemElems.filter(filterValue).length;
            if (count === 0) {
                $option.hide();
            } else {
                $option.show();
            }
        });
    }

    $grid.on('arrangeComplete', function (event, filteredItems) {
        if (!filteredItems.length) {
            $('.message-none-found').show();
        } else {
            $('.message-none-found').hide();
        }
    });

    // use value of search field to filter
    var $quicksearch = $('.custom-search').keyup(debounce(function () {
        qsRegex = new RegExp($quicksearch.val(), 'gi');
        $grid.isotope();
        updateFilterCounts();
    }, 200));

    // debounce so filtering doesn't happen every millisecond
    function debounce(fn, threshold) {
        var timeout;
        return function debounced() {
            if (timeout) {
                clearTimeout(timeout);
            }

            function delayed() {
                fn();
                timeout = null;
            }

            timeout = setTimeout(delayed, threshold || 100);
        }
    }

    function getHashFilter() {
        // get filter=filterName
        var matches = location.hash.match( /filter=([^&]+)/i );
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent( hashFilter );
    }

    function onHashchange() {
        var hashFilter = getHashFilter();
        // set selected class on button
        if ( hashFilter ) {
            var filters = hashFilter.split('.');
            filterValue = hashFilter;
            filters.forEach( function( filter ) {
                var option = $('.filters select').find("[data-filter='." + filter + "']");
                option.attr('selected','selected');
            });
            // trigger custom selects
            jcf.refreshAll();
        }
        // filter isotope
        $grid.isotope();
    }

    $(window).on( 'hashchange', onHashchange );

    // trigger event handler to init Isotope
    onHashchange();
});
